import './flow-item.css';

import { IonIcon } from '@ionic/react';
import { home } from 'ionicons/icons';
import { ReactElement } from 'react';
import { getLocalizedText } from '../../../../../../i18n/i18n.utils';
import { FlowItemSharedRef } from '../../../model/flow.types';
import { FlowItemBase } from './flow-item-base';

export interface StartItemComponentProps {
  canAddItem?: boolean;
  onAddItemsAfter: () => void;
}

const StartItemComponent = (props: StartItemComponentProps): ReactElement => {
  const { canAddItem, onAddItemsAfter } = props;

  return (
    <div className="flow-item-container">
      <FlowItemBase
        flowItem={{
          name: `${getLocalizedText('common:start')}`,
          parameters: [],
          ref: FlowItemSharedRef.START,
        }}
        canAddItem={canAddItem}
        onAddItemsAfter={onAddItemsAfter}
        icon={
          <div className="center bg-tint full-hw">
            <IonIcon icon={home} className="text-color-medium" />
          </div>
        }
      />
    </div>
  );
};

export { StartItemComponent };
